import { postRequest } from '../clients/axios';

export const postMyPlayer = async (playerId: number) => {
  const url = 'appuser/myPlayer';
  const payload = {
    playerId,
  };
  const response = await postRequest(url, payload);
  return response;
};
